import React from 'react';

export default function LighthouseViewer() {
  return (
    <div className="-m-8 w-[calc(100%+4rem)] h-[calc(100vh-0rem)]">
      <iframe
        src="https://lighthouse.reefos.ai"
        className="w-full h-full border-0"
        title="Lighthouse"
        allow="fullscreen"
      />
    </div>
  );
}